import { FC } from 'react';
import { theme } from 'antd';

const { useToken } = theme;

type Props = {
  width?: number;
  height?: number;
};

const ElectricalCabinetIcon: FC<Props> = ({ width = 18, height = 18 }) => {
  const { token } = useToken();

  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Cube">
        <path
          id="Vector"
          d="M15.7275 4.65128L9.54 1.26573C9.37468 1.17438 9.18888 1.12646 9 1.12646C8.81112 1.12646 8.62532 1.17438 8.46 1.26573L2.2725 4.65268C2.0958 4.74936 1.94829 4.89172 1.84539 5.06487C1.74248 5.23803 1.68796 5.43563 1.6875 5.63706V12.3617C1.68796 12.5632 1.74248 12.7608 1.84539 12.9339C1.94829 13.1071 2.0958 13.2494 2.2725 13.3461L8.46 16.7331C8.62532 16.8244 8.81112 16.8723 9 16.8723C9.18888 16.8723 9.37468 16.8244 9.54 16.7331L15.7275 13.3461C15.9042 13.2494 16.0517 13.1071 16.1546 12.9339C16.2575 12.7608 16.312 12.5632 16.3125 12.3617V5.63776C16.3124 5.43598 16.2581 5.23793 16.1551 5.06437C16.0522 4.89081 15.9045 4.74813 15.7275 4.65128ZM9 2.2501L14.6489 5.34385L9 8.4376L3.35109 5.34385L9 2.2501ZM2.8125 6.32823L8.4375 9.40651V15.4386L2.8125 12.3624V6.32823ZM9.5625 15.4386V9.40932L15.1875 6.32823V12.3596L9.5625 15.4386Z"
          fill={token.colorPrimary}
        />
      </g>
    </svg>
  );
};

export default ElectricalCabinetIcon;
